import React from 'react';
import { G, Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
  secondColor?: string;
}

export const SolarBubbleChatBoldIcon: React.FC<IconProps> = ({ size = 32 , color, secondColor}) => {
  const COLOR = color || '#332D6F';
  const SECOND_COLOR = secondColor || '#FDFDFD';
  return(

    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <G id="Bubble Chat">
        <G id="Vector">
          <Path
            d="M29.3327 11.3337C29.3327 6.54719 25.4525 2.66699 20.666 2.66699C17.8889 2.66699 15.4168 3.97672 13.8307 6.00994C20.5955 6.27147 25.9993 11.8382 25.9993 18.667C25.9993 18.8141 25.9968 18.9606 25.9919 19.1064L26.4349 19.225C27.7233 19.5697 28.9021 18.391 28.5573 17.1025L28.3875 16.4678C28.2503 15.9551 28.3328 15.4134 28.5533 14.9306C29.0538 13.835 29.3327 12.6169 29.3327 11.3337Z"
            fill={COLOR}
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.9993 18.667C23.9993 24.558 19.2237 29.3337 13.3327 29.3337C11.6853 29.3337 10.1252 28.9602 8.73236 28.2934C8.25363 28.0642 7.71126 27.9837 7.19853 28.1209L5.56381 28.5583C4.27537 28.9031 3.09662 27.7243 3.44136 26.4359L3.87876 24.8011C4.01594 24.2884 3.93547 23.746 3.70628 23.2673C3.03945 21.8745 2.66602 20.3143 2.66602 18.667C2.66602 12.776 7.44165 8.00033 13.3327 8.00033C19.2237 8.00033 23.9993 12.776 23.9993 18.667ZM8.66602 20.0003C9.4024 20.0003 9.99935 19.4034 9.99935 18.667C9.99935 17.9306 9.4024 17.3337 8.66602 17.3337C7.92964 17.3337 7.33268 17.9306 7.33268 18.667C7.33268 19.4034 7.92964 20.0003 8.66602 20.0003ZM13.3327 20.0003C14.0691 20.0003 14.666 19.4034 14.666 18.667C14.666 17.9306 14.0691 17.3337 13.3327 17.3337C12.5963 17.3337 11.9993 17.9306 11.9993 18.667C11.9993 19.4034 12.5963 20.0003 13.3327 20.0003ZM17.9993 20.0003C18.7357 20.0003 19.3327 19.4034 19.3327 18.667C19.3327 17.9306 18.7357 17.3337 17.9993 17.3337C17.263 17.3337 16.666 17.9306 16.666 18.667C16.666 19.4034 17.263 20.0003 17.9993 20.0003Z"
            fill={SECOND_COLOR}
          />
        </G>
      </G>
    </Svg>
  );
};
